import MainLayout from './MainLayout'
import './MainLayout.css'
import './background.css'

export default MainLayout



// WEBPACK FOOTER //
// ./src/containers/MainLayout/index.js